import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IGetRestaurantResponse } from '../../proto/restaurant/restaurant';

export interface IAuthState {
	selectedRestaurantId: string;
	tableSessionId?: string;
	userOrderSessionId?: string;
	csrfToken?: string;
	jwtToken?: string;
}

const initialState: IAuthState = {
	selectedRestaurantId: null,
	tableSessionId: null,
	userOrderSessionId: null,
	csrfToken: null,
	jwtToken: null,
};

export const {
	reducer,
	actions: { setAuthState, setUserOrderSessionId, setCsrfToken, setJwtToken },
} = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		setAuthState: (state, action: PayloadAction<{ tableSessionId: IGetRestaurantResponse['id']; restaurantId: IGetRestaurantResponse['id'] }>): void => {
			state.selectedRestaurantId = action.payload.restaurantId;
			state.tableSessionId = action.payload.tableSessionId;
		},
		setUserOrderSessionId: (state, action: PayloadAction<{ userOrderSessionId: IGetRestaurantResponse['id'] }>): void => {
			state.userOrderSessionId = action.payload.userOrderSessionId;
		},
		setCsrfToken: (state, action: PayloadAction<{ csrfToken: string }>): void => {
			state.csrfToken = action.payload.csrfToken;
		},
		setJwtToken: (state, action: PayloadAction<{ jwtToken: string }>): void => {
			state.jwtToken = action.payload.jwtToken;
		},
	},
});
